<template>
  <AccessGate :access-status="accessStatus">
    <BCollapse v-if="warningMessage" :show="!warningDismissed">
      <div class="bg-danger text-white px-3 py-1 small d-flex flex-row align-items-center">
        <div class="flex-grow-1 text-center fw-semibold">
          {{ warningMessage }}
        </div>
        <button type="button" class="text-white btn btn-sm btn-icon flex-shrink-0" @click="warningDismissed = true">
          <i class="bi-x-lg"/>
        </button>
      </div>
    </BCollapse>

    <slot name="top" />

    <!-- Full-page views share one instance across screen sizes. -->
    <div v-if="$slots.page" class="w-100 flex-grow-1 overflow-auto d-flex flex-column">
      <slot name="page" />
    </div>

    <!--
      Mobile UI
    -->
    <div v-else class="d-flex d-md-none flex-column align-items-stretch overflow-hidden flex-grow-1">

      <!-- Default slot -->
      <div v-if="!hasPaneLayout" class="w-100 h-100 overflow-auto">
        <slot />
      </div>

      <template v-else>
        <!-- If detail is provided, show just that -->
        <slot v-if="showDetail" name="detail" />

        <!-- If no detail, show list or map -->
        <template v-else>
          <!-- If map is provided and map is selected, show it -->
          <slot v-if="showMap && showMobileMap" name="map" />

          <!-- Or if list is provided, show it -->
          <slot v-else-if="showList" name="list" />

          <!-- Otherwise, show the default slot -->
          <slot v-else />

          <!-- Toggle between list and map if both are provided -->
          <div v-if="showMobileToggle" class="d-flex flex-row d-md-none px-4 py-2 border-top">
            <button type="button" :class="`me-2 btn btn-flat flex-grow-1 fw-semibold ${showMobileMap ? '' : 'text-primary'}`" @click.prevent="showMobileMap = false">
              <i class="bi-list me-1"/> List
            </button>
            <button type="button" :class="`ms-2 btn btn-flat flex-grow-1 fw-semibold ${showMobileMap ? 'text-primary' : ''}`" @click.prevent="showMobileMap = true">
              <i class="bi-map me-1"/> Map
            </button>
          </div>
        </template>
      </template>

    </div>

    <!--
      Desktop UI
    -->
    <div v-if="!$slots.page" class="d-none d-md-flex flex-row align-items-stretch w-100 overflow-hidden flex-grow-1">

      <!-- Default slot -->
      <div v-if="!hasPaneLayout" class="w-100 h-100 overflow-auto">
        <slot />
      </div>

      <div v-else class="flex-grow-1 d-flex flex-row align-items-stretch overflow-hidden justify-content-center">

        <div v-if="showList" :class="leftPaneClass">
          <div class="h-100 w-100 d-flex flex-column">
            <div class="flex-grow-1 overflow-auto" style="scroll-behavior: smooth">
              <slot name="list" />
            </div>
          </div>
        </div>
        <div v-if="showDetail" :class="leftPaneClass">
          <slot name="detail" />
        </div>
        <div v-if="showMap" :class="`flex-grow-1 d-flex flex-column overflow-hidden`">
          <div class="flex-grow-1 overflow-auto d-flex flex-column">
            <slot name="map" />
          </div>
        </div>
      </div>
    </div>

    <StaffPortalTourModal v-if="showStaffPortalTour" />
  </AccessGate>
</template>

<script>
import AccessGate from "@/components/common/AccessGate.vue";
import StaffPortalTourModal from "@/components/StaffPortalTourModal.vue";
import BCollapse from "@/components/common/BCollapse.vue";
import { ENABLE_STAFF_PORTAL_TOUR } from "@/featureFlags";
export default {
  components: {AccessGate, BCollapse, StaffPortalTourModal},
  props: {
    accessStatus: String,
    skipTour: Boolean,
    warningMessage: String,
    wideLeftBar: Boolean,
    showDetail: Boolean,
    showList: Boolean,
    showMap: Boolean
  },
  data() {
    return {
      warningDismissed: false,
      showMobileMap: false
    };
  },
  mounted() {
    this.showMobileMap = !this.showList;
  },
  computed: {
    hasPaneLayout() {
      return Boolean(this.showList || this.showDetail || this.showMap);
    },
    showMobileToggle() {
      return Boolean(this.showList && this.showMap && !this.showDetail);
    },
    leftPaneClass() {
      return `${this.wideLeftBar ? 'wide ' : ''}d-flex h-100 overflow-hidden left-bar border-end`;
    },
    showStaffPortalTour() {
      return ENABLE_STAFF_PORTAL_TOUR && !this.skipTour;
    }
  }
}
</script>

<style>
.left-bar {
  transition: width 250ms;
}
@media (max-width: 767px) {
  .left-bar {
    width: 100%;
  }
}
@media (min-width: 768px) {
  .left-bar {
    width: 50%;
    min-width: 350px;
    max-width: 500px;
  }
  .left-bar.wide {
    min-width: 600px;
    max-width: 900px;
    width: 60%;
  }
}
</style>
